<template>
  <alert
    class="ma-5 d-print-none"
    :color="alertConfig.color"
    :icon-size="30"
    :icon-top="alertConfig.body ? true : false"
  >
    <div
      class="d-flex align-center justify-space-between"
      :class="{ 'cursor-pointer': alertConfig.body }"
      @click="alertConfig.body && (isExpanded = !isExpanded)"
    >
      <div class="font-weight-bold">
        {{ alertConfig.title }}
      </div>

      <v-icon
        v-if="alertConfig.body"
        dense
        :color="alertConfig.color"
      >
        {{ isExpanded ? icons.mdiChevronUp : icons.mdiChevronDown }}
      </v-icon>
    </div>

    <div
      v-if="alertConfig.body && isExpanded"
      class="text-body-2 mt-2"
    >
      {{ alertConfig.body }}
    </div>
  </alert>
</template>

<script>
import { mdiChevronUp, mdiChevronDown } from '@mdi/js'
import { mapGetters } from 'vuex'
export default {
  name: 'InsuranceAlert',

  data() {
    return {
      isExpanded: false,
      icons: {
        mdiChevronUp,
        mdiChevronDown,
      },
    }
  },

  props: {
    patientId: {
      type: [String, Object],
      default: null
    },
  },
  computed: {
    ...mapGetters('patients', [
      'getInsuranceStatusById'
    ]),
    alertConfig() {
      const status = this.getInsuranceStatusById(this.patientId)
      // Variation 1: Insurance Type of the patient is empty
      if (status === 1) {
        return {
          color: 'warning',
          title: 'Physicians, we need your help with an insurance authorization for this patient!',
          body: 'Please continue with the current visit schedule and maintain non-surgical wound management until ' +
            'authorization is obtained for surgical procedures. We need your help to obtain insurance coverage ' +
            'for this visit and future visits for this patient, including coverage for procedures. If we don\'t ' +
            'obtain this now, it will become more difficult in the future. Please talk to the facility admissions ' +
            'office, case manager, or business office regarding insurance coverage and authorization, and coordinate ' +
            'with the facility on how to acquire this for the patient.'
        };
      }

      // Variation 2: Insurance Type is NOT empty AND AUTH REQUIRED AND (auth not obtained OR date empty)
      if (status === 2) {
        return {
          color: 'error',
          title: 'Patient does not have insurance; please continue with the visit. No insurance coverage ' +
            'for surgical procedures.',
          body: ''
        };
      }

      // Variation 3: Insurance Type is NOT empty AND auth is NOT required (or auth is complete)
      if (status === 3) {
        return {
          color: 'success',
          title: 'You are cleared for procedures.',
          body: ''
        };
      }
    }
  }
}
</script>
